// window.addEventListener('error', (e) => {
//   if (
//     e.message.includes('setAttribute') &&
//     e.filename.includes('element-ui.common.js')
//   ) {
//     e.preventDefault()
//     return false
//   }
// })
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import qs from 'qs'
import * as util from './unit/network'
// Vue.use(util)
Vue.prototype.$util = util;


import VueMeta from 'vue-meta'
Vue.use(VueMeta)
// import * as uni  from './../public/uni.webview.js'
// Vue.prototype.$uni = uni

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.prototype.$axios = axios
Vue.prototype.qs = qs

import wx from 'weixin-js-sdk'
Vue.prototype.wx = wx



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
